import React, { useRef, useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import { AnnouncementItem } from 'types';
import { RootState } from 'redux/root.reducer';
import { CFCProps } from 'types';
import Card from './card';
import { useEventListener } from 'utilities/hooks.util';
import { removeAllAnnouncements } from 'redux/announcement';

const Announcements: React.FC<Props> = ({ announcements }) => {
  const dispatch = useDispatch();
  const containerRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback(
    (evt: any) => {
      if (containerRef.current && evt.target) {
        if (!containerRef.current.contains(evt.target)) {
          dispatch(removeAllAnnouncements());
        }
      }
    },
    [containerRef, dispatch]
  );

  useEventListener('mousedown', handleClickOutside);
  useEventListener('touchstart', handleClickOutside);

  return (
    <>
      {announcements &&
        announcements.length > 0 &&
        announcements[0].noticeType === 'GENERAL' && (
          <div className="announcements-modal bx--modal is-visible">
            <div ref={containerRef} className="announcements-cards-container">
              {announcements?.map(
                (announcement: AnnouncementItem, inx: number) => (
                  <Card key={inx} data={announcement} />
                )
              )}
            </div>
          </div>
        )}
    </>
  );
};

const mapStateToProps = ({ announcementCache }: RootState) => ({
  announcements: announcementCache.announcements
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector>;

Announcements.displayName = 'AnnouncementsComponent';

export default React.memo(connector(Announcements));
